const countries: Record<string, string> = {
  'United States': 'US',
  'United States of America': 'US',
  USA: 'US',
  US: 'US',
  Canada: 'CA',
  CA: 'CA',
  Mexico: 'MX',
  MX: 'MX'
};

const states: Record<string, string> = {
  Alabama: 'AL',
  Alaska: 'AK',
  Arizona: 'AZ',
  Arkansas: 'AR',
  California: 'CA',
  Colorado: 'CO',
  Connecticut: 'CT',
  'District of Columbia': 'DC',
  Delaware: 'DE',
  Florida: 'FL',
  Georgia: 'GA',
  Hawaii: 'HI',
  Idaho: 'ID',
  Illinois: 'IL',
  Indiana: 'IN',
  Iowa: 'IA',
  Kansas: 'KS',
  Kentucky: 'KY',
  Louisiana: 'LA',
  Maine: 'ME',
  Maryland: 'MD',
  Massachusetts: 'MA',
  Michigan: 'MI',
  Minnesota: 'MN',
  Mississippi: 'MS',
  Missouri: 'MO',
  Montana: 'MT',
  Nebraska: 'NE',
  Nevada: 'NV',
  'New Hampshire': 'NH',
  'New Jersey': 'NJ',
  'New Mexico': 'NM',
  'New York': 'NY',
  'North Carolina': 'NC',
  'North Dakota': 'ND',
  Ohio: 'OH',
  Oklahoma: 'OK',
  Oregon: 'OR',
  Pennsylvania: 'PA',
  'Rhode Island': 'RI',
  'South Carolina': 'SC',
  'South Dakota': 'SD',
  Tennessee: 'TN',
  Texas: 'TX',
  Utah: 'UT',
  Vermont: 'VT',
  Virginia: 'VA',
  Washington: 'WA',
  'West Virginia': 'WV',
  Wisconsin: 'WI',
  Wyoming: 'WY',
  Alberta: 'AB',
  'British Columbia': 'BC',
  Manitoba: 'MB',
  Saskatchewan: 'SK',
  Ontario: 'ON',
  Québec: 'QC',
  Quebec: 'QC',
  'New Brunswick': 'NB',
  'Nova Scotia': 'NS',
  'Newfoundland and Labrador': 'NL',
  'Prince Edward Island': 'PE',
  Yukon: 'YT',
  'Northwest Territories': 'NT',
  Nunavut: 'NU'
};

const countryCodes = new Set(Object.values(countries));
const stateCodes = new Set(Object.values(states));

export function getCountryCode2Letter(
  value: string | null | undefined
): string | null {
  if (!value) return null;
  const normalized = String(value).trim();
  if (!normalized) return null;
  const mapped = countries[normalized];
  if (mapped) return mapped;
  const uppercase = normalized.toUpperCase();
  return normalized.length === 2 && countryCodes.has(uppercase)
    ? uppercase
    : null;
}

export function getStateCode2Letter(
  value: string | null | undefined
): string | null {
  if (!value) return null;
  const normalized = String(value).trim();
  if (!normalized) return null;
  const uppercase = normalized.toUpperCase();
  if (normalized.length === 2 && stateCodes.has(uppercase)) return uppercase;
  return states[normalized] ?? null;
}

export function getFinancierKey(
  value: string | null | undefined
): string | null {
  if (!value) return null;
  const normalized = String(value).replace(/\s+/g, '').toLowerCase();
  return normalized || null;
}
